const state = () => ({
  devLogin: {},
  requestData: {},
  feedbacks: [],
  selectedFeedbacksType: '',
  streamTitle: null,
  feedbacksPagination: {
    count: 0,
    offset: 0,
    limit: 20
  },
  feedbacksAverageScore: {},
  feedbacksExternalScore: {},
  isShowFeedbacksAdditional: true,
  isShowFeedbacksLoader: false,
  isFeedbacksLoading: false,
  isMoreFeedbacksLoading: false
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  },

  setFeedbacksType(state, type) {
    state.selectedFeedbacksType = type
  },

  setFeedbacksPagination(state, payload) {
    Object.assign(state.feedbacksPagination, payload)
  },

  setFeedbacksLoader(state, value) {
    state.isShowFeedbacksLoader = value
  },

  setIsFeedbacksLoading(state, value) {
    state.isFeedbacksLoading = value
  },

  setIsMoreFeedbacksLoading(state, value) {
    state.isMoreFeedbacksLoading = value
  }
}

const actions = {
  async fetchFeedbacksData({ state, commit }, params) {
    const isShowFeedbacksAdditional = !params?.stream_id

    await commit('set', {
      type: 'isShowFeedbacksAdditional',
      payload: isShowFeedbacksAdditional
    })

    commit('setIsFeedbacksLoading', true)

    try {
      const data = await this.$api.feedbacks.getFeedbacksData(params)

      const payload = state.isMoreFeedbacksLoading ? [...state.feedbacks].concat(data.feedbacks) : data.feedbacks
      await commit('set', {
        type: 'feedbacks',
        payload
      })

      if (data?.stream_title) {
        commit('set', {
          type: 'streamTitle',
          payload: data.stream_title
        })
      }

      commit('setFeedbacksPagination', data.pagination)
      commit('setIsFeedbacksLoading', false)
    } catch (e) {
      console.error(e)
    }

    if (state.isShowFeedbacksLoader) {
      commit('setFeedbacksLoader', false)
    }
  },

  async fetchFeedbacksAverageScore({ commit }, params) {
    try {
      const data = await this.$api.feedbacks.getFeedbacksAverageScore(params)

      await commit('set', {
        type: 'feedbacksAverageScore',
        payload: data
      })
    } catch (e) {
      console.error(e)
    }
  },

  async fetchFeedbacksExternalScore({ state, commit }) {
    if (!Object.keys(state.feedbacksExternalScore).length) {
      try {
        const data = await this.$api.feedbacks.getFeedbacksExternalScore()

        await commit('set', {
          type: 'feedbacksExternalScore',
          payload: data
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}

const getters = {
  getCurrentFeedbacks(state) {
    return state.feedbacks.slice(-500)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
